import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../../shared/user.service';
import { ErrorHandler } from '../../../../shared/ErrorHandler';
import { Search } from '../../../../shared/user.model';

@Component({
  selector: 'app-gen-incr-list',
  templateUrl: './gen-incr-list.component.html',
  styleUrls: ['./gen-incr-list.component.css']
})
export class GenIncrListComponent implements OnInit {
  data: any=[];
  DistrictsList: any=[];
  a: any ={};
  EmployeeList : any =[];
  maxcal: any;
  incrementValid : number;
  mode:any;
  
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) { }

  ngOnInit() {
   this.getDefaultData()
  }  

  getDefaultData(){
    this.data = this.userService.getAllDistrictName();
    this.data.subscribe(
      (response: any) => {
        this.DistrictsList = response;
      })

      this.a.EMP_DIVISION_ID = +localStorage.getItem('divisonId');
      this.generatelist(this.a.EMP_DIVISION_ID)

      this.data = this.userService.uspGetMaximumCalendar();
        this.data.subscribe(
        (response) => {
        this.maxcal = response;
        this.a.year =  this.maxcal-1; 
        this.validateIncrement(this.maxcal-1)       

      })
      
      
      //ValidateIncrementList
  }

  validateIncrement(year){
    this.data = this.userService.ValidateIncrementList(year);
    this.data.subscribe(
    (response) => {
    this.incrementValid = response;
    //this.a.year =  this.maxcal;        
  })
  }

  ngAfterViewInit() {
    var first = "--Select--"
    var year = 2019;
    var till = 3050;
    var options = "";
    for (var y = year; y <= till; y++) {
      // options = "<option>"+ first +"</option>";
      options += "<option>" + y + "</option>";
    }
    document.getElementById("year").innerHTML = "Select" + options;
  }

  generatelist(divisionId){    
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllIncrementingEmployeeList(divisionId);
    this.data.subscribe(
      (response: any) => {
        this.EmployeeList = response;      
        document.getElementById('loader-spinner').style.display = "none";
      },
      (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      }
    );
  }


  Save(year,list){    

    if(this.incrementValid == 1){
      swal('Warning!', 'Increment cannot applied for this year.', 'warning'); 
      return;
    }
    console.log('List');
    console.log(list);
    
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.AddIncrement(this.EmployeeList,year);
    this.data.subscribe(
      (response: any) => {
        //this.EmployeeList = response; 
        swal('Success!', ' Increment added Successfully .', 'success');
        this.router.navigate(['/home/increment']);     
        ///home/increment
        document.getElementById('loader-spinner').style.display = "none";
      },
      (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Increments/generate-increment-list/gen-incr-list/gen-incr-list.component.ts